import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button/index";
import HeaderRow from "@edaz/edazkit/HeaderRow/index";
import { observer } from "mobx-react-lite";
import RefundApprovalsViewModel from "viewModels/finance/refundApprovals/refundApprovalsViewModel";
import Tabs from "../../common/tabs";

const RefundApprovalsView: ViewComponent<RefundApprovalsViewModel> = observer(({ vm }) => {
  const exportApprovedClick = vm.exportApprovedClick;
  const approveAllClick = vm.approveAllClick;
  const approveSelectedEnabled = vm.activeChild?.self.selectedItems.size ? vm.activeChild?.self.selectedItems.size > 0 : false;

  return (
    <>
      <HeaderRow level={3} title={vm.name} className="mb-4">
        {approveSelectedEnabled && (
          <Button className="rounded" size="sm" onClick={vm.approveSelectedClick}>
            {vm.translate("approveSelected")}
          </Button>
        )}
        {approveAllClick && (
          <Button className="rounded" size="sm" onClick={approveAllClick} disabled={!vm.canApproveAll}>
            {vm.approveAllButtonTitle}
          </Button>
        )}
        {vm.canActionExportApprove && exportApprovedClick && (
          <Button className="rounded" size="sm" onClick={exportApprovedClick}>
            {vm.translate("exportApproved")}
          </Button>
        )}
      </HeaderRow>
      <Tabs vm={vm} />
    </>
  );
});

registerView(RefundApprovalsView, RefundApprovalsViewModel);
